// src/Routes.js
import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Layout from './app/Nav/layout';
import Login from './app/Pages/Login/login';
import Andondashboard from './app/Pages/Andon-Dashboard/andondashboard';
import Shift from './app/Pages/Shift/shift';
import MachineCard from '../src/app/Pages/Machinecard/machinecard';
import ShiftRegistration from './app/Pages/Shiftregistration/shiftreg';
import ComponentRegistration from './app/Pages/Componentregistration/componentreg';
import OperatorRegistration from './app/Pages/Operatorregistration/operatorreg';
import ReasonRegistration from './app/Pages/Reasonregistration/reasonreg';
import MachineList from './app/Pages/Machines/machine';
import Company from './app/Pages/Company/company';
import CurrentShift from './app/Pages/CurrentShift/CurrentShift';
import Analytics from './app/Pages/Analytics/analytics';
import GcodeOptimizer from './app/Pages/GcodeOptimizer/GcodeOptimizer';
import SmartOperator from './app/Pages/SmartOperator/SmartOperator';
import FloorLayout from './app/Pages/FloorLayout/FloorLayout';
import Allocation from './app/Pages/Allocations/allocation';
import OperatorDetails from './app/Pages/Operatordetails/operatordeatil'
import GrafanaEmbed from './app/Pages/MachinesMM/machinemm';
import MachineReport from './app/Pages/Reports/report';
import MachineUtilization from './app/Pages/Machineutilization/machineutilization';
import Operator from './app/Pages/Operator/operator';
import OeeDashboard from './app/Pages/Devices/deviceoee';
import Oee from './app/Pages/Oee/oee';
import NewAnalytics from './app/Pages/New-Analytics/new-analytics';
import { Box } from '@mui/material';
import NewDeviceOee from './app/Pages/NewDeviceOee/newdeviceoee';
import UserRegistration from './app/Pages/Userregistration/userreg';
import { COMPONENT_REGISTRY } from './app/Shared/constants/ComponentRegistry';
import ProtectedRoute from './app/Shared/gaurds/ProtectedRoute';
import { UserDetailsContext } from './app/Shared/context/UserDetailsContext';
import Cycletime from "./app/Pages/CycleTime/cycletime";
import AnalyticOee from "./app/Pages/CycleTime/analyticoee";
import Inprogress from "./app/Pages/CycleTime/inprogresscycle";
import Component from "./app/Pages/CycleTime/component";
import Component1 from "./app/Pages/CycleTime/component1";
import Summary from "./app/Pages/CycleTime/summary";
import PartCycleTime from './app/Pages/CycleTime/partcycletime';
import InprogressOee from './app/Pages/CycleTime/inprogressoee';
import MachineGroup from './app/Pages/Machinegroup/machinegroup';
import ProcessMaster from './app/Pages/ProcessMaster/processmaster';
import Scheduler from './app/Pages/Scheduler/Scheduler';
import NcLog from "./app/Pages/NcLog/NcLog";
import ReworkOrders from "./app/Pages/ReworkOrders/ReworkOrders";
import BomList from "./app/Pages/Bom/BomList";
import EcrList from "./app/Pages/Ecr/EcrList";
import EcnList from "./app/Pages/Ecn/EcnList";
import OperationMaster from "./app/Pages/OperationMaster/operationmaster";
import OperationSetup from "./app/Pages/OperationSetup/operationsetup";
import MachineCapabilities from "./app/Pages/MachineCapabilities/MachineCapabilities";
import CalibrationRegister from "./app/Pages/Calibration/CalibrationRegister";
import RecipeMaster from "./app/Pages/RecipeMaster/RecipeMaster";
import OperatorQualifications from "./app/Pages/OperatorQualifications/OperatorQualifications";
import HeatTreatCycles from "./app/Pages/HeatTreat/HeatTreatCycles";
import NdtInspections from "./app/Pages/NdtInspections/NdtInspections";
import AnodizeBatches from "./app/Pages/Anodize/AnodizeBatches";
import RouteCardFollower from "./app/Pages/RouteCardFollower/RouteCardFollower";
import RouteCardBuilder from "./app/Pages/RouteCardBuilder/RouteCardBuilder";
import JiggingPanels from "./app/Pages/JiggingPanels/JiggingPanels";
import AuditTrail from "./app/Pages/AuditTrail/AuditTrail";
import NadcapDashboard from "./app/Pages/NadcapDashboard/NadcapDashboard";
import MaterialCerts from "./app/Pages/MaterialCerts/MaterialCerts";
import BuildingsPage from './app/Pages/Buildings/buildings';
import OeeTv from './app/Pages/Oee-tv/oeetv';
import Teep from './app/Pages/Teep/teep';
import BluecardDetails from './app/Pages/BlueCardScreen/bluecarddetails';
import OperatorPerformanceDashboard from './app/Pages/Operator-Performance-Dashboard/OperatorPerformanceDashboard';
// ── PPW (Paperless Production Workflow) imports — merged from colleague's Paperless project 2026-06-18 ──
import DrawingsLibrary from './app/Pages/PPW/Drawings/DrawingsLibrary';
import DrawingDetail from './app/Pages/PPW/Drawings/DrawingDetail';
import AssemblyTree from './app/Pages/PPW/Drawings/AssemblyTree';
import OperationSequence from './app/Pages/PPW/Drawings/OperationSequence';
import ProjectsOrders from './app/Pages/PPW/Orders/ProjectsOrders';
import OrderDetail from './app/Pages/PPW/Orders/OrderDetail';
import PpwSettingsPage from './app/Pages/PPW/Settings/SettingsPage';
// === Inspection screens (Quality section, demo 2026-06-19) ===
import GaugingScreen   from './app/Pages/Inspection/inspection_gauging';
import VernierScreen   from './app/Pages/Inspection/inspection_vernier';
import CmmScreen       from './app/Pages/Inspection/inspection_cmm';
import CtMeterScreen   from './app/Pages/Inspection/inspection_ct_meter';
import ToolWearScreen  from './app/Pages/Inspection/inspection_tool_wear';
import InspectionDeviceSettings from './app/Pages/Inspection/inspection_device_settings';
import PfAccessGuard from './app/Pages/PPW/PfAccessGuard';
// ── Business (ERP) imports — merged from colleague's project 2026-06-18 ──
import Sales     from './app/Pages/Business/sales';
import Purchase  from './app/Pages/Business/purchase';
import Inventory from './app/Pages/Business/inventory';
import Bom       from './app/Pages/Business/bom';
import Mrp       from './app/Pages/Business/mrp';
import Finance   from './app/Pages/Business/finance';
import Crm       from './app/Pages/Business/crm';
import Workforce from './app/Pages/Business/workforce';
import Insights  from './app/Pages/Business/insights';
import AiConfiguration from './app/Pages/AiConfiguration/aiconfiguration';
import InterlockSettings from './app/Pages/InterlockSettings/interlocksettings';
import ToolDashboard from './app/Pages/ToolDashboard/tooldashboard';
import MaintenanceDashboard from './app/Pages/MaintenanceDashboard/maintenancedashboard';
import MesPlanning from './app/Pages/MesPlanning/MesPlanning';
import ProductionOrders from './app/Pages/ProductionOrders/productionorders';
import LabourBoard from './app/Pages/LabourBoard/LabourBoard';
import WorkOrders from './app/Pages/WorkOrders/WorkOrders';
import OperatorQueue from './app/Pages/OperatorQueue/OperatorQueue';
import MesReports from './app/Pages/Reports/Reports';


// Import other components for your routes

const AppRoutes = () => {
  const { userDetails } = useContext(UserDetailsContext);
  const [pageList, setPageList] = useState([]);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const usersDetailsData = typeof userDetails === 'string' ? JSON.parse(userDetails) : userDetails
    setPageList(usersDetailsData.pageList || []);
    setInitialized(true);
  }, [userDetails]);

  if (!initialized) return null;

  function PageErrorFallback({ error, resetError }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', color: '#fff',
      fontFamily: 'sans-serif', gap: '12px', textAlign: 'center', padding: '24px'
    }}>
      <h3 style={{ margin: 0 }}>This page ran into an error</h3>
      <p style={{ color: '#94a3b8', fontSize: '13px', margin: 0 }}>{error?.message}</p>
      <button onClick={resetError} style={{
        padding: '7px 18px', background: '#3b82f6', color: '#fff',
        border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px'
      }}>
        Retry
      </button>
    </div>
  );
}
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV" element={<Operator />} />
      <Route path="/smc_operator_bf9tz" element={<Operator />} />
      <Route path="/atech_operator_atc67" element={<Operator />} />
      <Route path="/marks_operator_ch8st" element={<Operator />} />
      <Route path="/makino_operator_av5tc" element={<Operator />} />
      <Route path="/gplast_operator_awe6tc" element={<Operator />} />
      <Route path="/operator_screen_biotek" element={<Operator />} />
      <Route path="/demo_operator_av3tc" element={<Operator />} />
      <Route path="/operator_screen" element={<Operator />} />
      <Route path="/Zx9R2tLmN7wQvB1cF4kH5oPjU6yE3aDgT8sK0qWl~1rMnOp" element={< Oee />} />
      <Route path="/Ze9R2tLmN7wQvB2cF4kH2oPjU1yE0aDgT4sK2qWl~3rMnOp" element={< Oee />} />
      <Route path="/pmi-oee-dashboard" element={< OeeTv />} />
      <Route path="/o" element={< Oee />} />
      <Route
        path="/operator"
        element={
          <ProtectedRoute allowed={pageList.includes('operator')}>
            <Operator />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Layout />}>
        <Route path="/operator-performance" element={<OperatorPerformanceDashboard />} />
        <Route path="/ai-configuration" element={<AiConfiguration />} />
        <Route path="/interlock-settings" element={<InterlockSettings />} />
        <Route path="/tool-dashboard" element={<ToolDashboard />} />
        <Route path="/maintenance-dashboard" element={<MaintenanceDashboard />} />
        {/* Inspection screens */}
        <Route path="/inspection/gauging"   element={<GaugingScreen />} />
        <Route path="/inspection/vernier"   element={<VernierScreen />} />
        <Route path="/inspection/cmm"       element={<CmmScreen />} />
        <Route path="/inspection/ct-meter"  element={<CtMeterScreen />} />
        <Route path="/inspection/tool-wear" element={<ToolWearScreen />} />
        <Route path="/inspection/devices" element={<InspectionDeviceSettings />} />
        {/* ── PPW routes — merged from colleague's Paperless project 2026-06-18 ── */}
        <Route path="/paperless-factory/drawings" element={<PfAccessGuard pageKey="drawings" label="Drawings Library"><DrawingsLibrary /></PfAccessGuard>} />
        <Route path="/paperless-factory/drawings/:id" element={<DrawingDetail />} />
        <Route path="/paperless-factory/drawings/:id/assembly" element={<AssemblyTree />} />
        <Route path="/paperless-factory/drawings/:id/operations" element={<OperationSequence />} />
        <Route path="/paperless-factory/orders" element={<PfAccessGuard pageKey="projects" label="Projects / Orders"><ProjectsOrders /></PfAccessGuard>} />
        <Route path="/paperless-factory/orders/:id" element={<OrderDetail />} />
        <Route path="/paperless-factory/settings" element={<PpwSettingsPage />} />
        <Route path="/mes-planning" element={<MesPlanning />} />
        <Route path="/production-orders" element={<ProductionOrders />} />
        <Route path="/labour-board" element={<LabourBoard />} />
        <Route path="/work-orders" element={<WorkOrders />} />
        <Route path="/operator-queue" element={<OperatorQueue />} />
        <Route path="/mes-reports" element={<MesReports />} />
        <Route path="/buildings" element={<BuildingsPage />} />
        <Route path="/sites" element={<BuildingsPage />} />
        <Route path="/process-master" element={<ProcessMaster />} />
        <Route path="/scheduler" element={<Scheduler />} />
        <Route path="/teep" element={<Teep />} />
        <Route path="/nc-log" element={<NcLog />} />
        <Route path="/rework-orders" element={<ReworkOrders />} />
        <Route path="/bom-master" element={<BomList />} />
        <Route path="/ecr" element={<EcrList />} />
        <Route path="/ecn" element={<EcnList />} />
        <Route path="/operation-master" element={<OperationMaster />} />
        <Route path="/operation-setup" element={<OperationSetup />} />
        <Route path="/machine-capabilities" element={<MachineCapabilities />} />
        <Route path="/calibration-register" element={<CalibrationRegister />} />
        <Route path="/recipe-master" element={<RecipeMaster />} />
        <Route path="/operator-qualifications" element={<OperatorQualifications />} />
        <Route path="/heat-treat-cycles" element={<HeatTreatCycles />} />
        <Route path="/ndt-inspections" element={<NdtInspections />} />
        <Route path="/anodize-batches" element={<AnodizeBatches />} />
        <Route path="/route-card-follower" element={<RouteCardFollower />} />
        <Route path="/route-card-builder" element={<RouteCardBuilder />} />
        <Route path="/jigging-panels" element={<JiggingPanels />} />
        <Route path="/audit-trail" element={<AuditTrail />} />
        <Route path="/nadcap-dashboard" element={<NadcapDashboard />} />
        <Route path="/material-certs" element={<MaterialCerts />} />
        <Route path="/gcode-optimizer" element={<GcodeOptimizer />} />
        <Route path="/smart-operator" element={<SmartOperator />} />
        <Route path="/floor-layout" element={<FloorLayout />} />
        {/* ── Business (ERP) static routes — merged from colleague's project 2026-06-18 ── */}
        <Route path="/sales"     element={<Sales />} />
        <Route path="/purchase"  element={<Purchase />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/bom"       element={<Bom />} />
        <Route path="/mrp"       element={<Mrp />} />
        <Route path="/finance"   element={<Finance />} />
        <Route path="/crm"       element={<Crm />} />
        <Route path="/workforce" element={<Workforce />} />
        <Route path="/insights"  element={<Insights />} />
        {pageList.map((page) => {

          const Component = COMPONENT_REGISTRY[page];
          if (!Component) return null;
          return (
            <Route
              key={page}
              path={`/${page}`}
              element={
                <ProtectedRoute allowed={pageList.includes(page)}>
                  <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
                    <PageErrorFallback error={error} resetError={resetError} />
                  )}>
                    <Component />
                  </Sentry.ErrorBoundary>
                </ProtectedRoute>
              }
            />
          );
        })}

        {pageList.includes("production-analysis") && (
          <>
            <Route path="/cycletime" element={<Cycletime />} />
            <Route path="/production-summary" element={<Component />} />
            <Route path="/production-runs" element={<Component1 />} />
            <Route path="/summary" element={<Summary />} />
            <Route path="/inprogresscycle" element={<Inprogress />} />
            <Route path="/analyticoee" element={<AnalyticOee />} />
            <Route path="/partwise-cycletime" element={<PartCycleTime />} />
            <Route path="/inprogressoee" element={<InprogressOee />} />
          </>
        )}

        {pageList.includes("bluecard") && (
          <>
            <Route path="/bluecarddetails" element={<BluecardDetails />} />
          </>
        )}

      </Route>
      <Route path="*" element={<Navigate to={'/'} replace />} />
    </Routes>
  )
}

export default AppRoutes;


